<div class="content-refiner-container" (dragover)="onDragOver($event)" (dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
  @if (isDraggingOver()) {
    <div class="drop-overlay">
      <div class="drop-content">
        <mat-icon>cloud_upload</mat-icon>
        <p>{{ 'FileUploader.DropFileHere' | translate }}</p>
      </div>
    </div>
  }
  <div class="header">
    <h2>{{ 'ContentRefiner.Title' | translate }}</h2>
    <button mat-icon-button (click)="close.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (isMobile()) {
    <mat-tab-group class="refiner-tab-group">
      <mat-tab [label]="'ContentRefiner.RefineButton' | translate">
        <div class="mobile-content-area custom-scrollbar">
          <ng-container *ngTemplateOutlet="refineTemplate"></ng-container>
        </div>
      </mat-tab>
      <mat-tab [label]="'ContentRefiner.VersionHistory' | translate">
        <div class="mobile-content-area custom-scrollbar">
          <ng-container *ngTemplateOutlet="historyTemplate"></ng-container>
        </div>
      </mat-tab>
    </mat-tab-group>
  } @else {
    <div class="content">
      <ng-container *ngTemplateOutlet="historyTemplate"></ng-container>
    </div>

    <ng-container *ngTemplateOutlet="refineTemplate"></ng-container>
  }
</div>

<ng-template #historyTemplate>
  <div class="history-section">
    <h3>{{ 'ContentRefiner.VersionHistory' | translate }}</h3>

    <div class="versions-list">
      @for (version of sortedVersions(); track version._id) {
        <app-version-tile
          [version]="version"
          [isActive]="currentVersionId() === version._id"
          [isInserting]="isInserting()"
          (restore)="restoreVersion(version)"
          (delete)="deleteVersion($event, version)"
          (insert)="confirmInsert($event)"
        ></app-version-tile>
      }
    </div>
  </div>
</ng-template>

<ng-template #refineTemplate>
  <div [class.refiner-footer]="!isMobile()" [class.refiner-footer-content]="isMobile()">
    <div class="instruction-area">
      <div class="template-selector mb-2">
        <app-template-picker [mode]="'TextGeneration'" [selectedTextGenerationTemplateID]="templateId" (onAIGenerationTemplateChange)="templateId = $event"></app-template-picker>
      </div>

      <label class="instruction-label">{{ 'ContentRefiner.InstructionLabel' | translate }}</label>
      <textarea [(ngModel)]="instruction" [placeholder]="'ContentRefiner.InstructionPlaceholder' | translate" rows="3" (keydown.enter)="$event.preventDefault(); refineContent()"></textarea>

      <!-- Attached Files -->
      @if (attachedFiles() && attachedFiles().length > 0) {
        <div class="attached-files-container">
          @for (file of attachedFiles(); track file.id) {
            @if (file.type === 'audio') {
              <app-voice-note-card [uploading]="file.uploading" [audioFile]="file.file" (removed)="removeAttachment(file.id)" class="mb-2" />
            } @else {
              <!-- Regular File Tile -->
              <div class="media-context-card">
                <div class="icon-wrapper">
                  @if (file.uploading) {
                    <mat-spinner diameter="20"></mat-spinner>
                  } @else {
                    @if (file.type === 'video') {
                      <mat-icon>videocam</mat-icon>
                    } @else if (file.type === 'image') {
                      <mat-icon>image</mat-icon>
                    } @else {
                      <mat-icon>description</mat-icon>
                    }
                  }
                </div>
                <div class="info-wrapper">
                  <h4 [matTooltip]="file.name">{{ file.name }}</h4>
                  @if (file.uploading) {
                    <p>{{ 'FileUploader.Uploading' | translate }}...</p>
                  } @else {
                    <p>{{ 'ContentGenerator.FileAttached' | translate }}</p>
                  }
                </div>
                <button type="button" mat-icon-button class="remove-btn" (click)="removeAttachment(file.id)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          }
        </div>
      }

      <!-- Attached External Contexts -->
      @if (attachedExternalContexts() && attachedExternalContexts().length > 0) {
        <div class="attached-files-container">
          @for (ext of attachedExternalContexts(); track ext.id) {
            <div class="media-context-card">
              <div class="icon-wrapper">
                <mat-icon>{{ ext.type === 'lecture' ? 'school' : ext.type === 'note' ? 'sticky_note_2' : 'article' }}</mat-icon>
              </div>
              <div class="info-wrapper">
                <h4 [matTooltip]="ext.title">{{ ext.title }}</h4>
                <p>{{ 'ContentGenerator.FileAttached' | translate }}</p>
              </div>
              <button type="button" mat-icon-button class="remove-btn" (click)="removeExternalContext(ext.id)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        </div>
      }

      <div class="file-actions flex gap-2 flex-wrap">
        <button type="button" mat-stroked-button (click)="fileInput.click()">
          <mat-icon>attach_file</mat-icon>
          {{ 'ContentGenerator.AttachFile' | translate }}
        </button>
        <button type="button" mat-stroked-button (click)="toggleContentSearcher()">
          <mat-icon>docs_add_on</mat-icon>
          {{ 'Searcher.AttachLibraryContent' | translate }}
        </button>
        <input type="file" #fileInput hidden multiple (change)="onFileSelected($event)" />
      </div>

      <!-- Voice Recording Mic Button -->
      <div class="flex justify-center mt-2">
        <app-voice-recorder-button (recorded)="onVoiceRecorded($event)" (recordingChange)="isRecordingVoice.set($event)" />
      </div>
    </div>

    <button mat-flat-button color="primary" class="refine-btn" [disabled]="(!instruction && templateId === 'none') || isGenerating()" (click)="refineContent()">
      <div class="btn-content">
        @if (isGenerating()) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          <mat-icon>add_circle</mat-icon>
        }
        <span>{{ 'ContentRefiner.RefineButton' | translate }}</span>
      </div>
    </button>
  </div>
</ng-template>
